import { downloadCSV } from '@helpers/downloadCSV';
import { getAmericanTime } from '@helpers/getAmericanTimezone';
import type { AdminUsersResponseUserDto } from 'app/API';

const headers = [
  'ID',
  'Created',
  'Name',
  'Email',
  'Phone',
  'Organizations',
  'Enabled',
  'How heard about us',
  'Email Verified',
];

type TUserCsvData = Pick<
  AdminUsersResponseUserDto,
  | 'id'
  | 'createdAt'
  | 'name'
  | 'lastname'
  | 'email'
  | 'phone'
  | 'organizations'
  | 'disabled'
  | 'howDidYouHearAboutUs'
  | 'emailVerified'
>;

export const downloadUsersCsv = (users: TUserCsvData[]) => {
  const array = users.map((data) => ({
    id: data.id,
    created: getAmericanTime(data.createdAt),
    name: `${data.name} ${data.lastname}`,
    email: data.email,
    phone: data.phone,
    organizations: (data.organizations || []).map((o) => `${o.name} <${o.id}>`).join(' / '),
    enabled: !data.disabled ? 'Y' : '',
    howDidYouHearAboutUs: data.howDidYouHearAboutUs ?? '',
    emailVerified: data.emailVerified ? 'Y' : '',
  }));
  return downloadCSV(array, headers);
};
